import { render, staticRenderFns } from "./detail-component-address.vue?vue&type=template&id=75696064&scoped=true"
import script from "./detail-component-address.vue?vue&type=script&lang=ts"
export * from "./detail-component-address.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75696064",
  null
  
)

export default component.exports